// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 86 ? "7069e3e8" : chunkId) + "." + {"86":"97297bf9e831585e","139":"e0b8da9815ba2cf2","559":"c09127ed268e0f1f","997":"f5927e124d6f5508"}[chunkId] + ".js";
};